import React, { useState } from 'react';
import { toast } from 'react-toastify';
import styles from './NewsLetter.module.scss';
import { validateEmail } from '@/helpers/props';
import { postNewsLetter } from '@/redux/store/actions/public';
import Button from '@/components/UI/button/Button';
import { useDispatch } from 'react-redux';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import TextField from '@/components/UI/textField/TextField';
const NewsLetter = () => {
  const dispatch = useDispatch();
  const [emailLoading, setEmailLoading] = useState<boolean>(false);
  const [email, setEmail] = useState('');
  const submitHandler = async e => {
    e.preventDefault();
    if (email) {
      if (validateEmail(email)) {
        setEmailLoading(true);
        await dispatch(postNewsLetter(email));
        setEmailLoading(false);
        setEmail('');
        toast.success('ثبت نام شما با موفقیت انجام شد', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      } else {
        toast.error('ایمیل اشتباه است', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      }
    }
  };
  return <Box className={styles['container']} data-sentry-element="Box" data-sentry-component="NewsLetter" data-sentry-source-file="NewsLetter.tsx">
      <Box component={'form'} onSubmit={submitHandler} className={styles['wrapper']} data-sentry-element="Box" data-sentry-source-file="NewsLetter.tsx">
        <Typography component={'h4'} variant={'title'} data-sentry-element="Typography" data-sentry-source-file="NewsLetter.tsx">
          از تخفیف‌ها و اخبار شب باخبر شوید
        </Typography>
        <TextField label="آدرس ایمیل خود را وارد نمائید" value={email} onClear={() => setEmail('')} onChange={e => setEmail(e.target.value)} data-sentry-element="TextField" data-sentry-source-file="NewsLetter.tsx" />
        <Box data-sentry-element="Box" data-sentry-source-file="NewsLetter.tsx">
          <Button format="outlined" type="submit" onClick={() => {}} loading={emailLoading} data-sentry-element="Button" data-sentry-source-file="NewsLetter.tsx">
            ثبت نام در خبرنامه
          </Button>
        </Box>
      </Box>
    </Box>;
};
export default NewsLetter;